import React, { useState } from 'react';
import { IconButton, Tooltip, Button, Snackbar } from '@mui/material';
import { ContentCopy, Check } from '@mui/icons-material';
import { t } from '../i18n';
import { pushEvent } from '../utils/analytics';

// Copy-to-clipboard control. Defaults to an icon button (matching the original
// result card); pass `variant="text"`/`label` to render a labelled button.
const CopyButton = ({ text, addressType, variant = 'icon', label, size = 'small' }) => {
  const [copied, setCopied] = useState(false);
  const [failed, setFailed] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      pushEvent('copy_address', { copy_type: addressType });
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setFailed(true);
      setTimeout(() => setFailed(false), 2000);
    }
  };

  const tip = t('Copy to clipboard', 'クリップボードにコピー');

  const control =
    variant === 'icon' ? (
      <Tooltip title={tip}>
        <IconButton
          size={size}
          onClick={handleCopy}
          sx={{ color: copied ? 'success.main' : 'primary.main' }}
          aria-label={tip}
        >
          {copied ? <Check fontSize="small" /> : <ContentCopy fontSize="small" />}
        </IconButton>
      </Tooltip>
    ) : (
      <Button
        size={size}
        onClick={handleCopy}
        startIcon={copied ? <Check /> : <ContentCopy />}
        color={copied ? 'success' : 'primary'}
      >
        {copied ? t('Copied', 'コピー済み') : label || t('Copy', 'コピー')}
      </Button>
    );

  return (
    <>
      {control}
      <Snackbar
        open={copied}
        autoHideDuration={2000}
        onClose={() => setCopied(false)}
        message={t('Copied to clipboard', 'クリップボードにコピーしました')}
      />
      <Snackbar
        open={failed}
        autoHideDuration={2000}
        onClose={() => setFailed(false)}
        message={t('Failed to copy', 'コピーに失敗しました')}
      />
    </>
  );
};

export default CopyButton;
